module.exports = __webpack_public_path__ + "static/media/how_sl.aa95b551.vtt";